import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { DocumentsDetails, } from 'src/app/models/interfaces.model';
import { DataDocumentService } from 'src/app/services/data-document.service';
import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/app/environments/environments';
import { take, forkJoin } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-modal-documentos-detail',
  templateUrl: './modal-documentos-detail.component.html',
  styleUrls: ['./modal-documentos-detail.component.css']
})
export class ModalDocumentosDetailsComponent {
  dataSource: any[] = [];
  modalTitle: string | null = null;
  documentsForm: FormGroup;
  loading = false;
  registers: DocumentsDetails[] = [];
  id_document: number = 0;

  headers = [
    {
      label: 'Fecha',
      field: 'CREATED_AT',
      disableSort: false,
    },
    {
      label: 'Código',
      field: 'CODIGO_DOCUMENTO',
      disableSort: false,
    },
    {
      label: 'Nombre',
      field: 'NOMBRE_DOCUMENTO',
      disableSort: false,
    },
    { 
      label: 'Ver Doc', 
      field: '', 
      disableSort: false 
    },
  ];

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    public modalRefDocuments: MdbModalRef<ModalDocumentosDetailsComponent>,
    public dataDocumentService: DataDocumentService) {
    this.documentsForm = this.fb.group({});
  }

  @ViewChild('table') table!: MdbTableDirective<DocumentsDetails>;
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;

  validateSelected(control: FormControl) {
    const selectedOptions = control.value;
    return selectedOptions && selectedOptions.length > 0 ? null : { required: true };
  }

  isExternalLink(url: string): SafeResourceUrl | string {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return 'assets/pdfs/' + url;
    }
  }

  openModalPDF(URLDOC: string) {
    console.log("se abre el pdf: ", URLDOC);
    const url = this.isExternalLink(URLDOC)
      ? URLDOC
      : 'assets/pdfs/' + URLDOC;
    window.open(url, '_blank');
  }

  getHistoricalDocuments(id_document: number) {
    const queryParams = {
      id_document,
    };
    this.dataDocumentService.getHistoricalDocumentsService(
      environment.apiUrl +'/'+ environment.GetHistoricalDocuments, queryParams
    ).pipe(take(1)).subscribe((data: any) => {
      // this.filas = data.length;
      console.log("data.data: ", data.data);
      if (data.data && data.data.length > 0) {
        this.dataSource = data.data.map((doc: any) => ({
          ID: doc.ID,
          CODIGO_DOCUMENTO: doc.CODIGO_DOCUMENTO,
          NOMBRE_DOCUMENTO: doc.NOMBRE_DOCUMENTO,
          CREACION_USUARIO: doc.CREACION_USUARIO,
          CREACION_FECHA: moment(doc.CREACION_FECHA).format('DD-MM-YYYY'),
          REVISION_USUARIO: doc.REVISION_USUARIO,
          REVISION_FECHA: moment(doc.REVISION_FECHA).format('DD-MM-YYYY'),
          APROBACION_USUARIO: doc.APROBACION_USUARIO,
          APROBACION_FECHA: moment(doc.APROBACION_FECHA).format('DD-MM-YYYY'),
          USUARIO_PUBLICACION: doc.USUARIO_PUBLICACION,
          PUBLICACION_FECHA: moment(doc.PUBLICACION_FECHA).format('DD-MM-YYYY'),
          PALABRAS_CLAVES: doc.PALABRAS_CLAVES,
          ID_TIPO_DOCUMENTO: doc.ID_TIPO_DOCUMENTO,
          ACTIVE: doc.ACTIVE,
          CREATED_AT: moment(doc.CREATED_AT).format('DD-MM-YYYY hh:mm'),
          GERENCIA_DOCUMENTO: doc.GERENCIA_DOCUMENTO,
          AREA_DOCUMENTO: doc.AREA_DOCUMENTO,
          ID_COMPANY: doc.ID_COMPANY,
          ID_APP: doc.ID_APP,
          ID_DOCUMENTO: doc.ID_DOCUMENTO,
          ID_HISTORICAL_USER: doc.ID_HISTORICAL_USER,
          URLDOC: doc.URLDOC,
        }));

        // this.Results = false;
        // this.qty = data.length;
        // this.loadingFull = false;
      } else {
        // this.Results = false;
        // this.qty = 0;
        // this.loadingFull = false;
      }
    });
  }
  
  async ngOnInit(): Promise<void> {
    this.getHistoricalDocuments(this.id_document);
    this.loading = true
    try {
      this.loading = false;
    } catch (error) {
      console.error('Error al cargar datos:', error);
    }
    this.loading = false
  }
}
